export const avatarColorList = ['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7'];

export const avatarShapes = {
  circle: 'circle',
  square: 'square',
};

export const dataHooks = {
  indication: 'avatar-indication',
  customIndication: 'avatar-customIndication',
  avatarCore: 'avatar-core',
  avatarWSR: 'avatar-wsr',
  loader: 'avatar-loader',
  textContainer: 'text-container',
};
